import React from 'react';
import cx from 'classnames';

import Align from '@marvelapp/marvel-ui/align';
import Heading from '@marvelapp/marvel-ui/heading';
import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import Position from '@marvelapp/marvel-ui/position';
import Toggle from '@marvelapp/marvel-ui/toggle';
import PropTypes from 'prop-types';

import Swirl from '../Icons/Swirl';
import styles from './BillingSwitch.css';

export default function BillingSwitch({
  onSwitch,
  yearlyPriceShown,
  discountValue,
}) {
  const badgeClasses = cx(styles.badge, {
    [styles.badgeGreen]: yearlyPriceShown,
    [styles.badgeTransparent]: !yearlyPriceShown,
  });
  return (
    <Position type="relative">
      <Align type="center">
        <InlineGrid size="xs">
          <Heading weight="semibold">Bill Monthly</Heading>
          <Toggle
            checked={yearlyPriceShown}
            name="toggle"
            onChange={onSwitch}
          />
          <Heading weight="semibold">Bill Yearly</Heading>
        </InlineGrid>
      </Align>
      <div className={styles.swirl}>
        <div className={badgeClasses}>
          Save up to {discountValue}% with yearly
        </div>
        <Swirl color="green" />
      </div>
    </Position>
  );
}

BillingSwitch.propTypes = {
  discountValue: PropTypes.number.isRequired,
  onSwitch: PropTypes.func.isRequired,
  yearlyPriceShown: PropTypes.bool.isRequired,
};

BillingSwitch.defaultProps = {
  yearlyPriceShown: true,
};



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/BillingSwitch/index.js